<template>
  <v-slide-y-transition mode="out-in">
    <div>
      <v-toolbar>
        <v-toolbar-title>Gedung & Ruang (drag & drop)</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn :loading="loading" class="primary" @click="save()">Save</v-btn>        
      </v-toolbar>      
      <v-progress-linear height="4" v-if="loading" class="ma-0 pa-0" :indeterminate="true"></v-progress-linear>
      <v-card>
        <v-card-text style="overflow: auto; width:100%; height:calc(100vh - 48px);">          
          <v-container grid-list-lg fluid pa-0>          
            <Container @drop="onDrop" orientation="horizontal" class="layout row wrap">
              <Draggable v-for="(item) in items" :key="item.id" class="flex">              
                <v-card class="draggable-item-horizontal" style="min-width:250px">
                  <v-toolbar :color="!item.id ? 'white': item.color ? item.color:''" dense flat dark>
                    <v-toolbar-title :class="!item.id ? 'grey--text':''">
                      {{item.nama}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>                  
                    <v-btn v-if="!item.id" fab small dark color="green" @click="ruangModel={id:null,name:null,code:null,seats:null}; ruangDialog=true">
                      <v-icon dark>add</v-icon>
                    </v-btn>
                    <v-icon v-else @click="updateGedung(item)">edit</v-icon>
                  </v-toolbar>                  
                  <v-card-text class="pa-0">
                    <Container @drop="(e) => onRuangDrop(item.id, e)" 
                      :get-ghost-parent="getGhostParent"  
                      :get-child-payload="getCardPayload(item.id)"                    
                      drag-class="card-ghost"
                      drop-class="card-ghost-drop"
                      group-name="col"
                      class="pa-3"
                      style="min-height:120px"
                    >
                      <Draggable v-for="ruang in item.ruangs" :key="ruang.id">
                        <div class="draggable-item">                       
                          <v-card class="grey lighten-3 mb-2">
                            <v-card-text class="pa-0">
                              <v-container class="pa-0">
                                <div class="layout row ma-0">
                                  <div class="xs4 flex ">
                                    <div class="layout column ma-0 justify-center align-center">
                                      <v-icon class="cursor" @click="updateRuang(ruang)" size="56px" :color="item.color ? item.color : ''">memory</v-icon>
                                    </div>
                                  </div>
                                  <div class="xs8 flex py-3" >                                    
                                    <div class="title">{{ruang.nama}} &nbsp;</div>
                                    <span class="caption"><small>kapasitas : {{ruang.kapasitas}} &nbsp;  ({{tingkats.find(x=>x.id===ruang.tingkat_id)?tingkats.find(x=>x.id===ruang.tingkat_id).description:''}} {{ruang.gender === 1?'Pa':'Pi'}})</small></span>
                                  </div>
                                </div>
                              </v-container>                               
                            </v-card-text>
                          </v-card>                        
                        </div>
                      </Draggable>
                    </Container>   
                    <v-btn icon small class="mx-3 mb-3" v-bind:color="item.color" @click="Object.assign(ruangModel,{id:null,parent_id:item.id,nama:null,color:null,kapasitas:null,tingkat_id:null});ruangDialog = true" dark><v-icon>add</v-icon></v-btn>
                  </v-card-text>
                </v-card>            
              </Draggable>   
              <v-btn :loading="loading" fab dark color="cyan" @click="gedungModel={id:null,nama:null,color:null};gedungDialog = true">
                <v-icon dark>add</v-icon>
              </v-btn>            
            </Container>        
          </v-container>        
        </v-card-text>      
      </v-card>   
      <v-dialog v-model="gedungDialog" scrollable max-width="300px">
        <v-card>
          <v-card-title>{{gedungModel.id ? 'Update Gedung' : 'New Gedung'}}</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 250px;">
            <v-text-field v-model="gedungModel.nama" label="nama" @keypress.enter="saveGedung()"></v-text-field>
            <slider-picker v-model="colors" style="width:100%" />
            <v-text-field v-model="gedungModel.color" label="Color"></v-text-field>            
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <!--<v-btn color="blue darken-1" flat @click="gedungDialog = false">Close</v-btn>-->
            <v-btn color="blue darken-1" flat @click="saveGedung();">Save</v-btn>
            <v-spacer></v-spacer>
            <v-icon v-if="gedungModel.id" color="red" @click="deleteGedung()">delete</v-icon>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="ruangDialog" scrollable max-width="300px">
        <v-card>
          <v-card-title>{{ruangModel.id ? 'Update Ruangan' : 'Ruangan Baru'}}</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 300px;">
            <v-text-field v-model="ruangModel.nama" label="name"></v-text-field>
            <v-text-field v-model="ruangModel.kapasitas" type="number" label="Kapasitas (seats)" @keypress.enter="saveRuang()"></v-text-field>
            <v-select :items="tingkats" label="Tingkat" v-model="ruangModel.tingkat_id" item-text="description" item-value="id"></v-select>
            <v-radio-group label="gender :" v-model="ruangModel.gender" row>
              <v-radio label="Pa" :value="1"></v-radio>
              <v-radio label="Pi" :value="2"></v-radio>            
            </v-radio-group>
            <!--<slider-picker v-model="colors" style="width:100%" />
            <v-text-field v-model="ruangModel.color" label="Color"></v-text-field>-->            
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <!--<v-btn color="blue darken-1" flat @click="gedungDialog = false">Close</v-btn>-->
            <v-btn color="blue darken-1" flat @click="saveRuang();">Save</v-btn>
            <v-spacer></v-spacer>
            <v-icon v-if="ruangModel.id" color="red" @click="deleteRuang()">delete</v-icon>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>    
  </v-slide-y-transition>  
</template>

<script>
import { Slider }  from 'vue-color';  
import { Container, Draggable } from 'vue-smooth-dnd'
import { applyDrag, generateItems } from '@/util/helpers'
import Model from '@/apps/admin/models/Gedung';  
const  model = new Model();


export default {  
  components: {Container, Draggable, 'slider-picker': Slider},
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      loading : false,
      gedungDialog: false,
      ruangDialog : false,      
      gedungModel:{
        id : null,
        nama : null,
        color : null,
        type : 1,                
      },
      ruangModel:{
        id : null,
        parent_id : null,
        nama : null,
        type : 2,
        gender : null,
        kapasitas : null,        
        color : null,
        tingkat_id : null,
      },
      items: [], 
      colors:{hex:'#40BF80'},
      tingkats : [],
    }
  },
  watch:{
    colors(newVal){this.gedungModel.color = newVal.hex; this.ruangModel.color = newVal.hex;}
  },
  mounted(){
    this.init();
    this.$watch(['gedungModel','color'].join('.'), (color)=>{
      this.colors = {hex:color};
    });
    model.tingkats().then(data=>{this.tingkats = data});
  },
  methods: {
    init(){
      this.loading = true;
      model.all().then(data=>{
        this.items = data;
        this.loading = false;
      });
    },
    
    save(){
      this.loading = true;
      model.save({items : this.items}).then(res=>{
        if(res.status === 200){  
          this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                
          this.init();
        }      
        this.loading = false;
      });
    }, 
    
    updateGedung(item){
      Object.assign(this.gedungModel, item);
      this.gedungDialog = true;
    },
    
    updateRuang(item){
      Object.assign(this.ruangModel, item);
      this.ruangDialog = true;
    },
    
    async saveGedung(){
      this.loading = true;      
      let res = this.gedungModel.id ? await model.update(this.gedungModel) : await model.create(this.gedungModel);
      if(res.status === 200){ this.gedungDialog = false; this.init(); }       
      this.loading = false;      
    },
    
    async saveRuang(){
      this.loading = true;
      let res = this.ruangModel.id ? await model.update(this.ruangModel) : await model.create(this.ruangModel);      
      if(res.status === 200){ this.init(); this.ruangDialog = false;}        
      this.loading = false;            
    },
    
    deleteGedung(){
      this.$swal({title: 'Are you sure?', text: "You won't be able to revert this!",  type: 'warning',showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'}).then((result) => {                 
        if (result.value) { 
          model.delete(this.gedungModel).then( res => {if(res.status === 200){this.init(); this.gedungDialog = false;}});
        }
      });    
    },
    
    deleteRuang(){
      this.$swal({title: 'Are you sure?', text: "You won't be able to revert this!",  type: 'warning',showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'}).then((result) => {                 
        if (result.value) { 
          model.delete(this.ruangModel).then(res=>{if(res.status === 200){this.save(); this.ruangDialog = false;}});
        }
      });    
    },
    
    validate(data){        
        data.forEach( (item) => {
          this.alert = {status: true, msg: item.message, field : item.field};
        });
    },    
    
    onDrop (dropResult) {
      this.items = applyDrag(this.items, dropResult);      
    },
    
    onRuangDrop (columnId, dropResult) {
      if (dropResult.removedIndex !== null || dropResult.addedIndex !== null) {
        const scene = this.items;
        const column = scene.filter(p => p.id === columnId)[0];
        const columnIndex = scene.indexOf(column);
        const newColumn = Object.assign({}, column);
        newColumn.ruangs = applyDrag(newColumn.ruangs, dropResult);
        scene.splice(columnIndex, 1, newColumn);
        this.items = scene;        
      }
    },
    
    getCardPayload (columnId) {
      return index => {
        return this.items.filter(p => p.id === columnId)[0].ruangs[index];
      }
    },
    
    getGhostParent(){
      return document.body;
    },    
  }
}
</script>
<style>
.card-ghost {
    transition: transform 0.18s ease;
    transform: rotateZ(5deg)
}

.card-ghost-drop {
    transition: transform 0.18s ease-in-out;
    transform: rotateZ(0deg)
}
</style>


